<template>

    <div class="table__wrapper table--requests">
        <table>
            <thead>
                <tr>
                    <th></th>
                    <th> Id </th>
                    <th> {{ trans('distrib.orders.tables.final_client') }} </th>
                    <th> {{ trans('distrib.orders.tables.nItems') }} </th>
                    <th> {{ trans('distrib.orders.tables.items') }} </th>
                    <th> {{ trans('distrib.orders.tables.date') }} </th>
                    <th> {{ trans('distrib.orders.tables.status') }} </th>
                    <th> {{ trans('distrib.orders.tables.agent') }} </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(req, reqix) in current_request" :key="reqix" :class="req.status">

                    <!-- Dot with pending status -->
                    <td>
                        <div class="has__tooltip">
                            <span></span>
                            <div class="td__tooltip pos--right">
                                <p class="title"> {{ trans('distrib.orders.status.pending_requests') }} </p>
                                <p>{{ trans('distrib.orders.status.pending_requests_msg') }}</p>
                            </div>
                        </div>
                    </td>

                    <td>
                        {{ req.id }}
                    </td>

                    <!-- Pic of the final client -->
                    <td>
                        <img :src="req.final_client.pic" :title="req.final_client.name">
                    </td>

                    <!-- Number of samples -->
                    <td>
                        {{req.num_items}}
                    </td>

                    <!--  Sample list-->
                    <td>
                        <div class="quick__bulks__wrapper" :class="bulksModifier(req.bulks.length)">
                            <div v-for="(mybulk, i) in quickBulksMaker(req.bulks)" :key="i" class="quick__bulk">
                                <span class="separator" :class="'separator--'+mybulk.logo_name"></span>
                                <p>
                                    <span>(x{{mybulk.num}})</span>
                                    {{mybulk.name}}
                                </p>
                            </div>
                        </div>
                        <div v-if="req.bulks.length > 3" class="remaining__bulks">
                            <p>
                                ...<span>(x{{req.num_items - req.bulks[0].num - req.bulks[1].num}})</span>
                                {{ trans('distrib.orders.tables.more_samples') }}
                                </p>
                            <div class="has__tooltip">
                                <a class="see__more">
                                    <i class="icon-anita-arrow_down"></i>
                                </a>
                                <div class="td__tooltip">
                                    <p class="title">{{ trans('distrib.orders.tables.fullItems') }}</p>
                                    <ul>
                                    <li v-for="(bulkrow, ix) in req.bulks" :key="ix">
                                        <span>x{{bulkrow.num}}</span>
                                        <div class="flex-element flex-row flex-align-center">
                                            <img :src="bulkrow.img" />
                                            <p>{{bulkrow.name}}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <span>x{{req.num_items}}</span>
                                        <p>{{ trans('distrib.orders.tables.total') }}</p>
                                    </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </td>

                    <!-- Date -->
                    <td>
                        <p class="time--date" v-if="req.created_at != null">
                            {{ formatDate(req.created_at) }}
                            <span>{{ formatYear(req.created_at) }} </span>
                        </p>
                    </td>

                    <!-- Status -->
                    <td class="status">
                        {{ capitalize(trans('distrib.orders.status.' + req.status)) }}
                    </td>

                    <!-- Agent -->
                    <td class="agent">
                        <a v-if="req.agent" :href="'mailto:'+ req.agent.email">
                            <img :src="'/user.pic/' + req.agent.id"/>
                            {{ formatAgent(req.agent.lastname) }}
                            <span>{{ formatNameAgent(req.agent.name) }}</span>
                        </a>
                        <span v-else-if="req.status === 'accepted'">
                            {{ trans('distrib.orders.status.assigning_agent') }}
                        </span>
                    </td>

                    <!-- Nedeed? -->
                    <td></td>

                </tr>

            </tbody>
        </table>

        <paginator v-if="pages.length>1" :numPages="pages.length" @goPage="goPage" />

    </div>

</template>

<script>

const PER_PAGE = 6;

function doPages(array, chunk) {
    const groups = [];

    for (let i = 0, j = array.length; i < j; i += chunk) {
        groups.push(array.slice(i, i + chunk));
    }

    return groups;
}

export default {

    props: [
        'requests',
    ],

    data() {
        const pages = doPages(this.requests.items, PER_PAGE);

        return {
            pages,
            current_request: pages[0],
            current_page: 0,
        };
    },
    methods: {
        formatDate(mydate) {
            return moment(mydate).format('DDMMM').replace('.', '').toString();
        },

        formatYear(mydate) {
            return moment(mydate).format('YYYY');
        },

        capitalize(value) {
            if (!value) return '';
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },

        formatAgent(val) {
            return val.replace(/ .*/, '');
        },

        formatNameAgent(val) {
            return val.substr(val.indexOf(' ') + 1);
        },
        goPage(page) {
            this.current_request = this.pages[page - 1];
        },

        amISelected(i) {

        },

        bulksModifier(num) {
            let modClass = 'modif--';
            (num < 3) ? modClass += num : modClass += 'multi';
            return modClass;
        },

        quickBulksMaker(bulks) {
            let qbulks = bulks;
            (bulks.length < 3) ? '' : (bulks.length === 3) ? '' : qbulks = qbulks.slice(0, 2);
            return qbulks;
        },

    }
};

</script>
